import type {
  Props as BreadcrumbProps,
} from '@sgcmpteltd/uikit-react/components/breadcrumb';
import {
  BREADCRUMB_TYPE_LINK,
  BREADCRUMB_TYPE_TEXT,
} from '@sgcmpteltd/uikit-react/components/breadcrumb';

import type { CamelCaseCarDetail } from '@/apis/server/new-car/v1/car-detail';
import { joinSgcmSite } from '@/utils/url/join/public';

export const breadcrumbList: (
  text: string
) => BreadcrumbProps['list'] = text => [
  {
    key: 'home',
    type: BREADCRUMB_TYPE_LINK,
    href: '/',
    text: 'Home',
  },
  {
    key: 'newCarsHome',
    type: BREADCRUMB_TYPE_LINK,
    href: joinSgcmSite('new_cars/index.php').toString(),
    text: 'New Cars',
  },
  {
    key: 'info',
    type: BREADCRUMB_TYPE_TEXT,
    text,
  },
];

export const createEyeotaAJSScriptTargetMapping = (
  data: CamelCaseCarDetail,
) => {
  const result = {
    cat: [
      'newcarintent',
      `new${data.make.toLowerCase().replace(/[-\s]/g, '')}`,
      `new${data.vehicleType.toLowerCase() === 'sports' ? 'sportscar' : data.vehicleType.toLowerCase()}`,
    ],
  };

  if (data.subModels[0]) {
    if (data.subModels[0].priceDetail.coeCategory) {
      result.cat.push(`newcat${data.subModels[0].priceDetail.coeCategory}`);
    }

    if (data.subModels[0].transmissionType) {
      result.cat.push(`newtrans${data.subModels[0].transmissionType === 'A' ? 'auto' : 'manual'}`);
    }

    if (data.subModels[0].specifications.fuelType) {
      result.cat.push(`new${data.subModels[0].specifications.fuelType.replace(/[-\s]/g, '')}`);
    }

    if (data.subModels[0].price) {
      const { price } = data.subModels[0];

      if (price < 100000) {
        result.cat.push('newpricebelow100k');
      } else if (price < 150000) {
        result.cat.push('newprice100kto150k');
      } else if (price < 200000) {
        result.cat.push('newprice150kto200k');
      } else if (price < 250000) {
        result.cat.push('newprice200kto250k');
      } else if (price < 300000) {
        result.cat.push('newprice250kto300k');
      } else if (price < 350000) {
        result.cat.push('newprice300kto350k');
      } else if (price < 400000) {
        result.cat.push('newprice350kto400k');
      } else if (price < 500000) {
        result.cat.push('newprice400kto500k');
      } else {
        result.cat.push('newpriceabove500k');
      }
    }

    if (data.subModels[0].specifications.engineCapacity) {
      const { engineCapacity } = data.subModels[0].specifications;

      if (engineCapacity < 661) {
        result.cat.push('newbelow661cc');
      } else if (engineCapacity <= 1600) {
        result.cat.push('new661ccto1600cc');
      } else if (engineCapacity <= 2000) {
        result.cat.push('new1601ccto2000cc');
      } else if (engineCapacity <= 3000) {
        result.cat.push('new2001ccto3000cc');
      } else {
        result.cat.push('newabove3000cc');
      }
    }
  }

  return result;
};
